import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'transformKey',
})
export class TransformKeyPipe implements PipeTransform {
  transform(value: any): string {
    if (!value) return value;

    // Replace underscores with spaces and capitalize each word
    return value
      .split('_')
      .map((word: string) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  }
}